import * as angular from 'angular';

class ConnectionPermissionsGroupDetailContainerController {}

/**
 * @todo (Franklin) 03/11/2020: Merge with {@link ConnectionPermissionsGroupDetailComponent} when ui router
 *       is upgraded to 1.x or this is migrated to Angular
 */
export const ConnectionPermissionsGroupDetailContainerComponent: angular.IComponentOptions = {
  controller: ConnectionPermissionsGroupDetailContainerController,
  controllerAs: 'ctrl',
  bindings: {},
  template: `
    <connection-permissions-group-detail
      group="ctrl.$resolve.userGroup"
      group-avatar="ctrl.$resolve.groupAvatar"
      group-name="ctrl.$resolve.groupName"
      group-data-source-entitlement="ctrl.$resolve.dataSourceEntitlement"
    />
  `,
};
